import CheckmarkOutline from '@carbon/icons-react/lib/CheckmarkOutline'
import { Partner } from 'graph/generated/payments/graphql-types'
import DownloadPdf, { IDownloadPdf } from 'lib/ui/DownloadPdf'
import PartnerDetails from 'lib/ui/DownloadPdf/PartnerDetails'
import TransactionPdfLayout, {
  ITransactionPdf
} from 'lib/ui/DownloadPdf/TransactionPdfLayout'

import { useCompanyAndInvoiceContext } from '@/hooks/providers/CompanyAndInvoiceProvider'

interface IPaymentPdf
  extends Pick<IDownloadPdf, 'buttonProps'>,
    ITransactionPdf {
  width?: string
}

const PaymentPdf = ({
  buttonProps,
  amount,
  invoiceAmount,
  totalAmount,
  date,
  invoiceNumber,
  paymentMethod,
  referenceId,
  width
}: IPaymentPdf) => {
  const { brandColor, company } = useCompanyAndInvoiceContext()

  return (
    <DownloadPdf
      buttonProps={buttonProps}
      buttonText='Download receipt'
      brandColor={brandColor}
      masthead={{
        circleContent: (
          <>
            Payment <br />
            Receipt <CheckmarkOutline size={32} />
          </>
        ),
        logo: company?.paymentsPortalCustomization?.logoUrl,
        logoContent: <PartnerDetails partner={company as Partner} />
      }}
      width={width}
    >
      <TransactionPdfLayout
        amount={amount}
        invoiceAmount={invoiceAmount}
        totalAmount={totalAmount}
        date={date}
        invoiceNumber={invoiceNumber}
        paymentMethod={paymentMethod}
        referenceId={referenceId}
      />
    </DownloadPdf>
  )
}

export default PaymentPdf
